import { cva } from "class-variance-authority";

export const inputVariants = cva(
  "px-3 py-2 border border-gray-200 text-gray-950 rounded-[6px] placeholder:text-gray-400 text-sm shadow-none bg-white h-10 disabled:bg-gray-100 appearance-none [&::-webkit-calendar-picker-indicator]:hidden [&::-webkit-calendar-picker-indicator]:appearance-none",
  {
    variants: {
      variant: {
        default: "",
        error: "border-red-600",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);
